import pagination from '@iso/lib/helpers/pagination';

const model = {
    ...pagination('stock').model,
};

export default model;